var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrim(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.7rem",
    height: "2.7rem",
    viewBox: "0 0 2048 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#695346",
    d: "M640 384H512V256h128zm768-128h128v128h-128zM640 640H512V512h128zm768-128h128v128h-128zM512 1664h128v128H512zm896 0h128v128h-128zm-896-256h128v128H512zm896 0h128v128h-128zM0 768h128v512H0zm256 0h128v512H256zm1408 0h128v512h-128zm384 0v512h-128V768zm-1536 0h1024v512H512zm128 384h768V896H640z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrim);
export default __webpack_public_path__ + "static/media/trim.2c51b7b5e864dfecedcbae1227a12d5d.svg";
export { ForwardRef as ReactComponent };